import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useAddAdminProxyMutation } from "@/redux/services/adminProxyApi"
import { setToast } from "@/redux/toastSlice"
import type { AddProxyPayload } from "@/types/entities/proxy"

export const useAddAdminProxy = () => {
  const dispatch = useAppDispatch()
  const [addAdminProxy, response] = useAddAdminProxyMutation()

  const handleAddAdminProxy = async (body: AddProxyPayload) => {
    try {
      const response = await addAdminProxy(body).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success add proxy",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { addAdminProxy: handleAddAdminProxy, response }
}
